import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ExquisiteSurfaceArtistry from "./sections/ExquisiteSurfaceArtistry";
import ExpertCleaningSolutions from "./sections/ExpertCleaningSolutions";
import TheVendiTrustPillars from "./sections/TheVendiTrustPillars";
import Testimonials from "./sections/Testimonials";
import InquiryPortal from "./sections/InquiryPortal";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ExquisiteSurfaceArtistry />
      <ExpertCleaningSolutions />
      <TheVendiTrustPillars />
      <Testimonials />
      <InquiryPortal />
      <Footer />
    </div>;
}